<template>
  <div class="courseList">
    <!-- 搜索 -->
    <div class="searchBox">
      <span v-show="!isCancelCourse" class="gobackBtn" @click="goBack">
        <van-icon name="arrow-left
"/>
      </span>
      <van-search v-model="searchText" :class="[isCancelCourse?'vanSearch1':'vanSearch2']"
                  :left-icon='require("../../../assets/images/icon/search.png")' class="vanSearch"
                  placeholder="开始搜索，从新妈变星妈" shape="round" @focus="searchFocus"/>
    </div>
    <!-- 搜索记录、为您推荐 -->
    <!-- <layer-float :recordList="recordList" v-show="!layerFloatShowCourse" :searchIndex="'course'"></layer-float> -->
    <div v-show="layerFloatShowCourse" class="course-content">
      <div class="touchBox">
        <!-- banner -->
        <div v-if="bannerList!=null && bannerList.length > 0" class="banner_course">
          <mySwiper :autoplay="bannerList.length>1? true : false" :autoplayNumber="3000"
                    :loop="bannerList.length>1? true : false" :paginationFlag="bannerList.length>1? true : false"
                    :slidesNum="1" :swipeid="'banner_course_swiper'"
                    style="overflow:hidden">
            <div v-for="(img,index) in bannerList.slice(0,5)" :key="img.id" slot="swiper-con" class="swiper-slide"
                 @click="toBannerClick(img,index)">
              <a :href="img.link"><span :style="{backgroundImage: 'url(' + img.imgUrl + ')'}"></span></a>
            </div>
          </mySwiper>
          <course-next ref="coursenext" @courseData="getCourseNext" @gioFloor="gioFloorClick"></course-next>
        </div>

        <!-- 本周新鲜好课 -->
        <!-- <div class="course_recommend"> -->
        <!-- <div class="module_title" v-if="weekCourse!=null || courseNextData"> -->
        <!-- <h1 class="title">星妈课堂</h1> -->
        <!-- </div> -->
        <!-- <div class="course_swiper_container" v-if="weekCourse!=null"> -->
        <!-- <div class="recommend_courses_list courses_list" slot="swiper-con" @click.stop="toCourseLink(true,weekCourse,'本周好课','')"> -->
        <!-- <div class="imgCon" @click.stop="toCourseLink(true,weekCourse,'本周好课')" v-lazy:background-image="weekCourse.imgUrl"></div> -->
        <!-- <div class="con"> -->
        <!-- <h3 class="tit">{{weekCourse.title}}</h3> -->
        <!-- <div>
          <div
            class="expert_con"
            @click.stop="toExpertHome(weekCourse,'本周好课')"
            v-if="weekCourse.expert"
          >
            授课嘉宾：{{weekCourse.expert.realName}} {{weekCourse.expert.hospital}}{{weekCourse.expert.position}}
          </div>
          <van-icon name="arrow" class="expert_icon"></van-icon>
        </div>-->
        <!-- <div class="tips" v-if="weekCourse.tagList">
          <span :key="tag.id" v-for="tag in weekCourse.tagList.slice(0,1)">{{tag.name}}</span>
        </div>-->

        <!-- 疫情 -->
        <!-- <div class="expert_center">
          <div class="expert_con" @click.stop="toExpertHome(weekCourse,'本周好课')" v-if="weekCourse.expert">
            {{weekCourse.expert.position}}
          </div>
          <div class="tips" v-if="weekCourse.tlist">
            <span :key="tag.id" v-for="tag in weekCourse.tlist.slice(0,1)">{{tag.name}}</span>
          </div>
          <span @click.stop="courseShare(weekCourse)" class="course_share"><img src="../../../assets/images/icon/share1.png" alt="" class="audio">分享</span>
        </div> -->
        <!-- 疫情 -->

        <!-- <div class="bottom">
          <div class="views fl">{{fomatterNum(weekCourse.signUpNum)}}妈妈已学习</div>
          <div class="course_btn fr" @click.stop="toCourseLink(true,weekCourse,'本周好课','',1)">
            <img class="video" v-if="weekCourse.type==2" src="../../../assets/images/icon/video.png" /><img class="active" v-else-if="weekCourse.type==3" src="../../../assets/images/icon/active.png" /><img v-else src="../../../assets/images/icon/audio.png" />马上听课
          </div>
        </div> -->
        <!-- </div> -->
        <!-- </div> -->
        <!-- </div> -->
        <!-- 下期预告 -->

        <!-- </div> -->
        <!-- 专题 -->
        <!-- <div class="course_special" v-if="noticeBannerList!=null && noticeBannerList.length > 0 ">
          <h1 class="module_title">
            <span class="title">大咖育儿</span>
          </h1>
          <div class="course_special_banner">
            <mySwiper v-if="noticeBannerList && noticeBannerList.length == 1" :slidesNum="1" :loop="false" :swipeid="'course_special_banner1'">
              <div class="swiper-slide" @click="toOuterLink(img.link,index)" slot="swiper-con" v-for="(img,index) in noticeBannerList" :key="img.id" v-lazy:background-image="img.imgUrl"></div>
            </mySwiper>
            <mySwiper v-else-if="noticeBannerList && noticeBannerList.length == 2" :spaceBetweenNum="12" :slidesNum="2" :loop="false" :swipeid="'course_special_banner2'">
              <div class="swiper-slide" @click="toOuterLink(img.link,index)" slot="swiper-con" v-for="(img,index) in noticeBannerList" :key="img.id" v-lazy:background-image="img.imgUrl"></div>
            </mySwiper>
            <mySwiper v-else-if="noticeBannerList && noticeBannerList.length > 2" :slidesNum="2.5" :spaceBetweenNum="12" :loop="false" :swipeid="'course_special_banner3'">
              <div class="swiper-slide" @click="toOuterLink(img.link,index)" slot="swiper-con" v-for="(img,index) in noticeBannerList" :key="img.id" v-lazy:background-image="img.imgUrl"></div>
            </mySwiper>
          </div>
        </div> -->
        <!-- 按照分类筛选课程 -->
        <div class="course_allList">
          <van-tabs v-model="curTagId" :duration='0' :offset-top="searchHeight" :swipe-threshold="3.5" animated
                    class="expert_question_box"
                    color="#D4A437" line-height="3px" line-width="36px" sticky
                    title-active-color="#333333" title-inactive-color="#333333" @click="switchPage">
            <van-tab v-for="item in tagList" :key="item.id" :class="'courses_all courses coursesList'+item.fnTagId"
                     :name="item.fnTagId"
                     :title="item.name">
              <van-list v-model="courseListLoading" :error.sync="courseListError" :finished="courseListFinished"
                        :finished-text="finishText"
                        :offset="10" class="ex_courses_list" error-text="请求失败，点击重新加载"
                        @load="getCourseList(curTagId,item.name)">
                <div v-for="course in courseAllList" :key="course.id"
                     :class="'tag_courses_list courses_list wrap'+item.fnTagId+course.page"
                     @click.stop="toCourseLink(false,course,'本周好课',item.name)">
                  <div v-lazy:background-image="course.imgUrl" :data='JSON.stringify(course)'
                       class="imgCon" @click.stop="toCourseLink(false,course,'本周好课',item.name)"></div>
                  <div class="con">
                    <h3 class="tit">{{ course.title }}</h3>
                    <p class="over-text">授课嘉宾：{{ course.expert.realName }} {{ course.expert.position }}</p>
                    <div>
                      <span class="bottomItem"
                      ><img
                          class="icon"
                          src="./../../../assets/images/food/browse.png"
                      /><span>{{ fomatterNum(course.signUpNum) || 0 }}</span></span
                      >
                      <div>
                        <span class="course_share" @click.stop="courseShare(course,item.name)">分享</span>
                        <span @click.stop="toCourseLink(false,course,'本周好课',item.name,1)">马上听课</span>
                      </div>


                    </div>

                    <!-- 疫情 -->
                    <!-- <div class="expert_center">
                      <div class="expert_con" v-if="course.expert" @click.stop="toExpertHome(course,'本周好课',item.name)">
                        {{course.expert.position}}
                      </div>
                      <div class="tips" v-if="course.tlist">
                        <span :key="tag.id" v-for="tag in course.tlist.slice(0,1)">{{tag.name}}</span>
                      </div>
                      <span @click.stop="courseShare(course,item.name)" class="course_share"><img src="../../../assets/images/icon/share1.png" alt="" class="audio">分享</span>
                    </div> -->
                    <!-- 疫情 -->

                    <!-- <div class="bottom">
                      <div class="views fl">{{fomatterNum(course.signUpNum)}}妈妈已学习</div>
                      <div class="course_btn fr" @click.stop="toCourseLink(false,course,'本周好课',item.name,1)">
                        <img class="video" v-if="course.type==2" src="../../../assets/images/icon/video.png" /><img class="active" v-else-if="course.type==3" src="../../../assets/images/icon/active.png" /><img v-else src="../../../assets/images/icon/audio.png" />马上听课
                      </div>
                    </div> -->
                  </div>
                </div>
              </van-list>
            </van-tab>
          </van-tabs>
        </div>
        <!-- 分类下拉按钮 -->
        <span class="tag_slide tag_down" @click.stop="packUp('down')"></span>
        <!-- 返回顶部 -->
        <to-top></to-top>
      </div>
      <!-- 全部分类列表 -->
      <div class="tagAllListMask" @click.stop="packUp('up')">
        <div class="tagAllList">
          <p class="tagAlltitle">分类 <span @click.stop="packUp('up')">
              <van-icon name="arrow-up"/>
            </span></p>
          <div class="class-list">
            <div v-for="(item,index) in tagListTitle" :key="index" class="list-wrap">
              <div class="big-title">{{ item.fnTagId != 0 ? item.name : '' }}</div>
              <div :class="item.fnTagId==curTagId ? 'hotTag small-title':''||item.fnTagId == 0?'small-title':''"
                   @click="switchPageList(item)">{{ item.fnTagId == 0 ? item.name : '' }}
              </div>
              <div v-for="(items,index) in item.tagList" :key="index+1" :class="items.fnTagId==curTagId ? 'hotTag':''"
                   class="small-title" @click="switchPageList(items)">{{ items.name }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 星妈课堂海报 -->
      <div class="canvasposter" @touchmove.prevent @mousewheel.prevent>
        <div class="share_box">
          <img :src="src" alt="" class="share-image" @touchend="posterSaveEnd($event)"
               @touchstart="posterSaveStart($event)">
          <canvasPoster :painting="painting" class="poster" @fail="fail" @success="success">

          </canvasPoster>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="less">
// .courseList{
//   position: fixed;
//   left:0; top:0; width:100%; height:100%; overflow: auto;
//   -webkit-overflow-scrolling: touch
// }
.courseList {
  min-height: 100%;
  padding-top: 58px;
  // position: relative;
  .module_title {
    color: #333;
    padding: 16px 12px 7px;
    line-height: 20px;

    .title {
      font-size: @indexFontSize18;
      font-weight: bold;
    }
  }

  // 搜索
  .searchBox {
    width: 100%;
    background: @expertFontColor255;
    overflow: hidden;
    padding-bottom: 12px;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 98;

    .van-search {
      font-size: @indexFontSize12;
      float: left;

      .van-search__action {
        padding: 0 12px;
        font-size: @indexFontSize14;
      }

      .van-field__control {
        padding-left: 2px;
      }
    }

    .vanSearch1 {
      width: 89%;
      padding: 12px 0 0 12px;
    }

    .vanSearch2 {
      width: 90%;
      padding: 12px 0 0 0;
    }

    @media screen and (max-width: 640px) {
      .vanSearch1 {
        width: 87%;
      }

      .vanSearch2 {
        width: 326px;
      }
    }

    span.canBtn {
      display: inline-block;
      float: right;
      font-size: @indexFontSize14;
      color: @expertFontColor51;
      padding: 20px 12px 10px 7px;
    }

    span.gobackBtn {
      width: 20px;
      height: 20px;
      display: inline-block;
      float: left;
      font-size: @indexFontSize20;
      color: @expertFontColor51;
      padding: 18px 10px 0 7px;

      .van-icon {
        float: left;
        vertical-align: middle;
      }
    }
  }

  // banner
  .banner_course {
    padding: 0px 12px 0;
    background: @expertFontColor255;
    overflow: hidden;

    /deep/ .swiper-container {
      overflow: hidden !important;
    }
  }

  // 本周新鲜好课
  .course_recommend {
    background-color: @expertFontColor255;
    margin-bottom: 8px;
    overflow: hidden;
    padding-bottom: 15px;

    .course_swiper_container {
      padding: 0 12px 12px;
    }
  }

  // 专题
  .course_special {
    background: @expertFontColor255;

    .course_special_banner {
      padding: 13px 12px 20px;
      overflow: hidden;
    }
  }

  // 标签下拉按钮
  .tag_slide {
    width: 22px;
    height: 20px;
    text-align: center;
    font-size: @indexFontSize12;
    display: inline-block;
    position: absolute;
    bottom: 10px;
    right: 12px;
  }

  .tag_down {
    background: url(../../../assets/images/icon/down.png) no-repeat center right;
    background-size: 14px 8px;
    display: none;
  }

  // 课程列表
  .recommend_courses_list {
    height: 154px;
    background: @expertFontColor255;
    box-shadow: 0px 4px 8px 0px rgba(16, 24, 29, 0.02);
    border-radius: 8px;
    border: 1px solid @expertBorderColor242;
    overflow: hidden;
    box-sizing: border-box;
    position: relative;
    padding: 10px 10px 10px 120px;

    .imgCon {
      width: 110px;
      height: 152px;
      position: absolute;
      top: 0;
      left: 0;
      background-size: cover;
      background-color: @expertBorderColor242;
      background-position: center;
    }
  }

  .courses_list {
    .con {
      height: 110px;
      position: relative;

      .tit {
        font-size: @indexFontSize14;
        color: @expertFontColor51;
        line-height: 1.57em;
        // height: 3.14em;
        margin-bottom: 5px;
        font-weight: 500;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2; // 控制多行的行数
        -webkit-box-orient: vertical;
        word-wrap: break-word;
        font-weight: 500;
        font-size: 15px;
        font-family: PingFangSC-Medium, PingFang SC;
        line-height: 21px;
        // margin-top: 10px;
      }

      > .over-text {
        margin-top: 10px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #D4A437;
        line-height: 12px;
      }

      .bottomItem {
        line-height: 20px;
        font-size: 12px;
        color: #999;

        .icon {
          width: 12px;
          height: 10px;
          margin-right: 3px;
          vertical-align: middle;
        }

        .icon1 {
          width: 10px;
        }

        span {
          vertical-align: -9%;
        }
      }

      > div {
        width: 250px;
        position: absolute;
        bottom: 0px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        > div {
          display: flex;
          align-items: center;

          span:nth-of-type(1) {
            margin-right: 10px;
            display: inline-block;
            width: 78px;
            height: 26px;
            border-radius: 24px;
            border: 1px solid #ff67c1;
            text-align: center;
            line-height: 24px;
            font-size: 12px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #ff67c1;
            box-sizing: border-box;
          }

          span:nth-of-type(2) {
            display: inline-block;
            text-align: center;
            width: 78px;
            height: 26px;
            background: linear-gradient(270deg, #ff67c1 0%, #ff67c1 100%);
            border-radius: 24px;
            font-size: 12px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #FFFFFF;
            line-height: 26px;
          }
        }
      }

      // 疫情
      .expert_center {
        overflow: hidden;
        position: relative;

        .expert_con {
          max-width: 55%;
          font-size: @indexFontSize12;
          color: @mainColor;
          margin-bottom: 5px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          position: relative;
          display: inline-block;
        }

        .tips {
          margin-bottom: 5px;
          height: 22px;

          span {
            font-size: @indexFontSize12;
            height: 20px;
            border-radius: 4px;
            border: 1px solid @mainColor;
            border-radius: 4px;
            padding: 0 4px;
            height: 1.67em;
            line-height: 1.67em;
            display: inline-block;
            box-sizing: border-box;
            color: @mainColor;
            margin-right: 4px;
            max-width: 83px;
            overflow: hidden;
          }
        }

        .course_share {
          display: block;
          width: 94px;
          height: 32px;
          border: 1px solid rgba(212, 164, 55, 1);
          border-radius: 24px;
          text-align: center;
          font-size: @indexFontSize14;
          color: rgba(212, 164, 55, 1);
          line-height: 32px;
          position: absolute;
          top: 0;
          right: 0;

          img {
            vertical-align: middle;
            margin-right: 3px;
          }

          .audio {
            width: 16px;
            height: 16px;
          }
        }
      }

      // 疫情

      .expert_con {
        max-width: 90%;
        font-size: @indexFontSize12;
        color: @mainColor;
        margin-bottom: 5px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        position: relative;
        display: inline-block;
      }

      .expert_icon {
        color: @mainColor;
        position: absolute;
        top: 52px;
        right: 10px;
        height: 12px;
      }

      .tips {
        margin-bottom: 5px;
        height: 22px;

        span {
          font-size: @indexFontSize12;
          height: 20px;
          border-radius: 4px;
          border: 1px solid @mainColor;
          border-radius: 4px;
          padding: 0 4px;
          height: 1.67em;
          line-height: 1.67em;
          display: inline-block;
          box-sizing: border-box;
          color: @mainColor;
          margin-right: 4px;
        }
      }

      .bottom {
        line-height: 2.8em;

        .views {
          font-size: @indexFontSize12;
          color: @expertFontColor153;
        }

        .course_btn {
          display: block;
          width: 96px;
          height: 32px;
          background: linear-gradient(270deg,
          @mainColor 0%,
          rgba(229, 191, 93, 1) 100%);
          line-height: 35px;
          border-radius: 24px;
          text-align: center;
          font-size: @indexFontSize14;
          color: @expertFontColor255;

          img {
            width: 15px;
            margin-right: 4px;
            position: relative;
            top: 1px;
          }

          img.video {
            width: 16px;
            vertical-align: top;
            margin-top: 8px;
          }

          img.active {
            width: 17px;
            vertical-align: top;
            margin-top: 9px;
          }
        }
      }
    }
  }

  // 按照分类筛选课程
  .course_allList {
    width: 100%;
    display: none;
    margin-top: 8px;

    .van-tabs__nav {
      margin-left: 0px !important;
    }

    .van-tabs__wrap {
      position: relative;
      background: @expertFontColor255;
    }

    .van-tabs__content {
    }

    .van-hairline--top-bottom::after {
      border-top: 0;
    }

    .van-tabs__nav {
      margin-right: 34px;
      margin-left: 12px;

      .van-tab {
        line-height: 50px;
        font-size: @indexFontSize14;
        font-weight: 500;

        .van-tab__text {
          position: initial;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }

      .van-tab--active {
        font-size: @indexFontSize16;
        font-weight: bold;
      }
    }

    .courses_all {
      border-bottom: 2px solid @expertBorderColor242;
    }

    .courses {
      .ex_courses_list {
        background: @expertFontColor255;
        overflow: hidden;

        .tag_courses_list {
          margin: 16px 12px 0;
          border: 0;
          border-bottom: 1px solid @expertBorderColor242;
          background: @expertFontColor255;
          height: 110px;
          overflow: hidden;
          position: relative;
          padding: 0 0 16px 100px;

          .imgCon {
            border-radius: 8px;
            overflow: hidden;
            width: 80px;
            height: 110px;
            position: absolute;
            top: 0;
            left: 0;
            background-size: cover;
            background-color: @expertBorderColor242;
            background-position: center;
          }
        }

        .tag_courses_list:last-child {
          border-bottom: 0;
        }
      }
    }
  }

  // 全部分类列表
  .tagAllListMask {
    width: 100%;
    height: 100%;
    background: @expertColorMask;
    position: fixed;
    top: 46px;
    left: 0;
    right: 0;
    margin: auto;
    z-index: 99;
    display: none;

    .tagAllList {
      background: @expertFontColor255;

      .tagAlltitle {
        padding: 20px 12px 10px 12px;
        font-size: 16px;
        font-weight: bold;
        color: @expertFontColor51;
        line-height: 16px;
        display: flex;
        justify-content: space-between;

        span {
          width: 15px;
          height: 8px;
        }
      }

      .class-list {
        padding: 0 12px;
        font-size: 14px;
        font-weight: 400;
        color: @expertFontColor51;
        line-height: 14px;
        display: flex;
        flex-wrap: wrap;
        overflow: auto;

        .list-wrap {
          width: 100%;

          .hotTag {
            color: @mainColor;
          }

          .big-title {
            padding-bottom: 12px;
            color: #333;
            font-size: 14px;
            font-weight: bold;
            line-height: 16px;
          }

          .small-title {
            display: inline-flex;
            padding: 8px 12px;
            text-align: center;
            background: @expertBorderColor242;
            border-radius: 15px;
            margin-right: 12px;
            margin-bottom: 20px;
          }
        }

        .active {
          color: #d4a437;
        }

        .tag {
          padding: 8px 12px;
          text-align: center;
          background: @expertBorderColor242;
          border-radius: 15px;
          margin-right: 12px;
          margin-bottom: 20px;
        }

        .hotTag {
          color: @mainColor;
        }
      }
    }
  }

  // 疫情星妈课堂海报
  .canvasposter {
    display: none;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    z-index: 1000;

    .share_box {
      width: 254px;
      height: 454.5px;
      position: absolute;
      top: 0;
      bottom: 0;
      right: 0;
      left: 0;
      margin: auto;

      .share-image {
        position: absolute;
        width: 254.5px;
        height: auto;
        z-index: 1000;
      }
    }
  }
}
</style>

<script>
import canvasPoster from "@/components/poster/canvas-poster.vue"; //疫情星妈课堂海报
import {drawPoster} from '@/components/poster/posterjs/painter.js'; //疫情星妈课堂海报
import mySwiper from "@/components/common/mySwiper/mySwiper.vue";
import {fomatterNum, getCookie, is_weixin} from "@/assets/js/common.js";
import layerFloat from "@/components/contents/searchCommon/history.vue";
import courseNext from "@/components/contents/course/signUpToast_v1.vue";
import toTop from "@/components/common/toTop.vue";
import {Exposurer_course} from '../../../assets/js/Exposure'

export default {
  name: "courseList",
  components: {
    mySwiper,
    layerFloat,
    courseNext,
    toTop,
    canvasPoster
  },
  data() {
    return {
      isCancelCourse: false,
      searchText: "",
      recordList: "",
      layerFloatShowCourse: true, //搜索记录显示
      searchWordShow: true, //搜索关键词显示
      bannerList: null, //banner图
      noticeBannerList: null, //专题流程banner图
      weekCourse: null, //本周新鲜好课
      courseNextData: false,
      tagList: [], //分类列表
      courseAllList: [], //搜索课程列表
      curTagId: 0, //当前分类
      switchTagId: 0,
      courseParams: {
        page: 1,
        size: 25,
        flag: true,
        curPage: 1
      },
      direction: "down",
      MaxNameLength: 60,
      courseListLoading: false,
      courseListFinished: false,
      courseListError: false,
      finishText: "",
      userInfo: null,
      winScrollTop: 0,
      src: '',
      painting: {},
      userAvatar: '',
      userName: '',
      tagListTitle: [],
      tabClassId: '',
      searchHeight: '57',
      num: 0
    };
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.$store.commit("changeIncludes", ["home", "courseIndex"]);
      // vm.$refs.coursenext.getNoticeCouese();
    });
  },
  computed: {},
  watch: {
    searchText: {
      handler: function () {
        var that = this
        var _sum = 60;
        that.MaxNameLength = _sum - that.searchText.length
      },
      deep: true
    },
    $route(to, from) {
      if (from.name == 'commonSearch') {
        this.layerFloatShowCourse = true
        this.isCancelCourse = false;
      }
    }
  },
  mounted() {
    this.searchHeight = document.getElementsByClassName('searchBox')[0].clientHeight - 8
    if (this.$route.query.pageSource && this.$route.query.pageSource == "momclasspostscan") {
      gio('page.set', {'momclasspostscan': '星妈课堂分享海报'});
    } else {
      gio('page.set', {'menu_pvar': '星妈课堂'});
    }
    this.getBannerList("newCourse"); //获取banner
    this.getTagList(); //获取所有分类
    this.getBannerList("noticeCourse"); //获取专题流程banner
    $(window).bind("scroll", this.handleScroll);
    var shareDataParams = {
      shareLink: location.href.split("#")[0],
      shareDesc: "每周三晚8点，三甲医院权威专家，在线直播实时问答",
      shareTitle: "星妈课堂",
      imgUrl: "https://image-mom.feihe.com/wxshare/xingmaketang.jpg" //必须是绝对路径
    };
    this.wxJsSet.wxShare("fx", shareDataParams, this);
    //监听滚动条滚动
    $(window).scroll(this.inputBlur);
    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual'
    }

    // 疫情
    this.getUserName();
  },
  methods: {
    // 疫情
    getUserName: async function () {
      try {
        const {headImgurl, nickName} = await getHeadImgAndName()
        this.setCookie("xmh_headimgurl", headImgurl, 365);
        this.setCookie("xmh_nickname", nickName, 365);
        this.userName = nickName
        this.userAvatar = headImgurl
      } catch (err) {

      }
    },
    // getUserName: function () {
    //   if ((this.getCookie("xmh_nickname") == null || this.getCookie("xmh_nickname") == "") || (this.getCookie("xmh_headimgurl") == null || this.getCookie("xmh_headimgurl") == "")) {
    //     this.$http.get("/wechat/getUserInfoByOpenId", { openId: getCookie("xmh_openid") }, res => {
    //       if (res.code === "200") {
    //         this.userName = res.data.nickname
    //         this.userAvatar = res.data.headimgurl
    //         document.cookie = `xmh_headimgurl=${this.userAvatar}`;
    //         document.cookie = 'xmh_nickname=' + escape(this.userName);
    //       }
    //     });
    //   }
    // },

    // 星妈课堂疫情
    courseShare: function (weekCourse, name) {
      if (this.getCookie("xmh_openid") == null || this.getCookie("xmh_openid") == "") {
        location.href = "/xmh/v2/wechat/oauth2/authorize?url=" + encodeURIComponent(window.location.href);
      } else {
        $(".canvasposter").css("display", "block")
        this.posterMsg = weekCourse
        const params = {
          type: 'pro' // 尝试换一下base,image
        }
        this.drawPoster(params, this.posterMsg).then(res => {
          // console.log(this.painting, 9, 'painting')
          this.painting = res
          this.painting = res
        });
        // gio点击埋点
        gio("track", "momclasspage_shareclass");
      }
      if (name) this.sensorsCourseClick(weekCourse, "分享点击");
    },
    // 星妈课堂疫情海报保存
    success(src) {
      console.log(src, 'canvas')
      this.src = src
    },
    fail(err) {
      console.log('fail', err)
    },
    // 星妈课堂疫情
    posterSaveStart: function (e) {
      e.stopPropagation();
      clearTimeout(this.posterTime);
      this.posterTime = setTimeout(function () {
        gio("track", "momclasspost_save")
      }, 500); //这里设置长按响应时间
    },
    posterSaveEnd: function (e) {
      e.stopPropagation();
      clearTimeout(this.posterTime);
    },

    fomatterNum, is_weixin, getCookie, drawPoster,
    // 去掉小键盘
    inputBlur() {
      // $('.van-field__control').blur();
    },
    // 获取banner列表
    getBannerList: function (type) {
      if (type == "newCourse") {
        this.$http.get("/cms/banner_new/list", {type: type, sign: '2'}, res => {
          if (res.code === "200") {
            this.bannerList = res.data;
          }
        });
      } else {
        this.$http.get("/cms/banner/list", {type: type}, res => {
          if (res.code === "200") {
            this.noticeBannerList = res.data.slice(0, 3);
            for (var i = 0; i < this.noticeBannerList.length; i++) {
              if (this.noticeBannerList[i].link.indexOf("harvard") != -1) {
                var link = this.noticeBannerList[i].link + '&source=course'
                this.noticeBannerList[i].link = link
              }
            }
          }
        });
      }
    },
    // 获取下期预告
    getCourseNext: function (val) {
      this.courseNextData = val;
    },
    // 根据分类获取课程列表和本周新鲜好课
    getCourseList: function (tagId, itemName) {
      this.tagId = tagId
      return this.$http.post("/motherCourse/getCourseListByType", {}, {
        type: tagId,
        pageNum: this.courseParams.page,
        pageSize: this.courseParams.size
      }, res => {
        this.courseListLoading = false;
        if (res.code === 200) {
          var newCourseList = [];
          res.data.content.forEach((val, index, arr) => {
            val.page = this.courseParams.page;
            this.courseParams.curPage = this.courseParams.page;
            newCourseList.push(val)
          })

          this.courseAllList = this.courseAllList.concat(newCourseList);
          this.courseTotal = res.data.totalElements || 0;
          this.is_successful = true
          if (this.courseParams.page >= Math.ceil(res.data.totalElements / this.courseParams.size) || Math.ceil(res.data.totalElements / this.courseParams.size) === 0) {
            this.courseListFinished = true;
            this.finishText = "——已经到底了哦——";
          } else {
            this.courseParams.page += 1;
          }
          if (this.curTagId == 0) {
            this.weekCourse = this.courseAllList[0];
          }

          setTimeout(() => {
            Exposurer_course.observe('.wrap' + this.curTagId + this.courseParams.curPage, false, {
              tagListTitle: this.tagListTitle,
              tagId: this.curTagId,
              type: "course"
            });
          }, 300)
        } else {
          this.is_successful = false
          this.courseListLoading = false;
          this.courseListError = true;
        }
      }, res => {
        this.is_successful = false
        this.courseListLoading = false;
        this.courseListError = true;
      }, 'lucky');
    },
    // 切换分类
    switchPage: async function (name, title) {
      sensors.track('OperateClick', {
        operate_name: 'tab栏',
        operate_content: '精选课程',
        position: 4,
        content_name: title

      })
      if ($(".van-sticky").css("position") == "fixed") {
        $(".van-tabs__content").css("min-height", document.body.clientHeight - $(".van-sticky").outerHeight() + "px");
        if ($(".searchBox").css("position") == "fixed") {
          $(".van-tabs__content").css("min-height", document.body.clientHeight - $(".van-sticky").outerHeight() - $(".searchBox").height() + "px");
        }
      }
      this.tagList.forEach(item => {
        if (item.name == title) {
          this.tabClassId = item.id;
        }
      })
      if (this.switchTagId == name) return false;
      this.courseListFinished = false;
      this.courseListLoading = true;
      this.courseAllList = [];
      this.courseParams.page = 1;
      this.curTagId = name;
      this.switchTagId = name;
      await this.getCourseList(this.tabClassId);
      const tag = this.tagList.find(item => item.id == name)
      let firstName
      if (tag.fnTagId == 0) {
        firstName = "精选课程"
      } else {
        firstName = this.tagListTitle.find(item => item.id == tag.parentId).name
      }
      sensors.track('CourseTabClickResult', {
        course_class1: firstName,
        course_class2: title,
        search_number: this.courseTotal,
        page_name: this.$route.meta.title,
        is_successful: this.is_successful
      });
    },
    switchPageList: async function (item, num) {
      $(".tagAllList").slideUp(300);
      $(".tagAllListMask").fadeOut(100);
      $("body").css({"position": "initial", "top": "auto"});
      $(window).scrollTop(this.winScrollTop);
      if ($(".van-sticky").css("position") == "fixed") {
        $(".van-tabs__content").css("min-height", document.body.clientHeight - $(".van-sticky").outerHeight() + "px");
        if ($(".searchBox").css("position") == "fixed") {
          $(".van-tabs__content").css("min-height", document.body.clientHeight - $(".van-sticky").outerHeight() - $(".searchBox").height() + "px");
        }
      }
      if (this.switchTagId == item.id) return false;
      this.courseListFinished = false;
      this.courseListLoading = true;
      this.courseAllList = [];
      this.courseParams.page = 1;
      this.curTagId = item.fnTagId;
      this.switchTagId = item.fnTagId;
      await this.getCourseList(this.curTagId);
      // console.log(this.tagListTitle, 1234)
      let firstName
      if (item.id == 0) {
        firstName = "精选课程"
      } else {
        firstName = this.tagListTitle.find(i => item.parentId == i.fnTagId).name
      }
      sensors.track('CourseTabClickResult', {
        course_class1: firstName,
        course_class2: item.name,
        search_number: this.courseTotal,
        page_name: this.$route.meta.title,
        is_successful: this.is_successful
      });
    },
    // 获取分类列表
    getTagList: function () {
      this.$http.get("/motherCourse/getCourseTags", {}, res => {
        if (res.code === 200) {
          this.tagList = [{name: "最新好课", id: 0, fnTagId: 0}];
          this.tagListTitle = [{name: "最新好课", id: 0, fnTagId: 0}];
          // this.tagList = this.tagList.concat(res.data);
          for (var i = 0; i < res.data.length; i++) {
            // if (res.data[i].parentId == '0') {
            this.tagListTitle.push(res.data[i])
            // }
            for (var j = 0; j < res.data[i].tagList.length; j++) {
              this.tagList.push(res.data[i].tagList[j]);
            }
          }
          console.log(this.tagListTitle, 'tagListTitle')
          console.log(this.tagList, 'tagListTitle')
          $(".course_allList").css("display", "block");
          $(".van-tabs__wrap").append($(".tag_slide"));
          $(".tag_down").css("display", "block");
        }
      }, null, 'lucky');
    },
    // 点击下拉所有分类
    packUp: function (type) {
      if (type == "down") {
        $(".class-list").css("max-height", (document.body.clientHeight - $(".searchBox").outerHeight(true) - $(".tagAlltitle").outerHeight(true)) + "px");
        $(".van-tabs__content").css("min-height", document.body.clientHeight - $(".van-sticky").outerHeight() - $(".searchBox").height() + "px");
        $(".searchBox").fadeIn(100);
        $(".searchBox").css("position", "fixed");
        $(".tagAllListMask").fadeIn(100);
        $(".tagAllList").delay(50).slideDown(300);
        this.winScrollTop = $(window).scrollTop();
        if (this.winScrollTop <= (document.getElementsByClassName("course_allList")[0].offsetTop - 44) / (375 / $("body")[0].clientWidth)) {
          this.winScrollTop = (document.getElementsByClassName("course_allList")[0].offsetTop - 44) / (375 / $("body")[0].clientWidth);
        }
        if (window.scrollY < document.getElementsByClassName("course_allList")[0].offsetTop) {
          $("body").animate({
            "top": -this.winScrollTop + "px"
          });
        }
        if (this.direction == "down") {
          $(".searchBox").fadeIn(100);
          $(".searchBox").css("position", "fixed");
        }
        $("body").css({
          "position": "fixed", "top": -this.winScrollTop + "px"
        });
        $(".van-sticky").css("top", 46 / (375 / $("body")[0].clientWidth) + "px");
      } else {
        $(".tagAllList").slideUp(300);
        $(".tagAllListMask").fadeOut(100);
        $("body").css({"position": "initial", "top": "auto"});
        $(window).scrollTop(this.winScrollTop);
      }
    },
    // 点击去听课
    toCourseLink: function (bool, course, type, name, clickType) {
      console.log(course, 'course----333')
      if (type == "本周好课") {
        this.xmCourseClickGio({'floor_var': type, 'position_var': type, "contentName_var": course.title});
      } else {
        this.xmCourseClickGio({'floor_var': type, 'position_var': name, "contentName_var": course.title});
      }
      if (clickType && clickType != null) {
        var labelName = null;
        if (course.tlist != null && course.tlist.length != 0) {
          labelName = course.tlist[0].name;
        }
        gio('track', 'classClick', {'courseLabel_var': labelName, 'courseTitle_var': course.title});
      }
      this.$http.get("/motherCourse/courseWatch", {id: course.id}, res => {
        if (res.code === 200) {
          this.taskFinish(course)
          setTimeout(function () {
            location.href = course.courseUrl;
          }, 200);
        }
      }, null, 'lucky');
      if (bool) {
        sensors.track('OperateClick', {
          operate_name: "卡片",
          operate_content: '星妈课堂',
          position: 2,
          content_name: '星妈课堂'
        })
      } else {
        sensors.track('OperateClick', {
          operate_name: "tab切换",
          operate_content: name,
          position: 4,
          content_name: course.title
        })
      }
      let firstName
      if (this.tagId != 0) {
        firstName = this.tagListTitle.find(item => item.tagId == course.tlist[0].id).name
      } else {
        firstName = "精品课程"
      }
      sensors.track('ListenCourseClick', {
        page_name: this.$route.meta.title,
        course_title: course.title,
        expert_name: course.expert.realName,
        expert_hospital: course.expert.hospital,
        expert_level: course.expert.position.split("")[1],
        course_class1: firstName,
        course_class2: name
      })
      var clickType = clickType ? "马上听课点击" : "";
      this.sensorsCourseClick(course, clickType);
    },
    // 完成浏览任务
    taskFinish: function (course) {
      this.userInfo = JSON.parse(localStorage.getItem("userInfo"));

      if (this.userInfo) {
        var date = Date.parse(new Date());
        var string = '34f9cd73a0044a2e8d47e85de884b8b1300777';
        var taskid = '5';
        var relation = 'xmkt_' + course.id;
        var md5 = this.$md5(string + taskid + relation + date);
        var openid = this.getCookie('xmh_openid')
        this.$http.post('/taskEventController/finish/xmh', {}, {
          crm_id: this.userInfo.crm_id,
          task_id: '5',
          relation_id: 'xmkt_' + course.id,
          open_id: openid,
          timestamp: date,
          rand: md5
        }, res => {
          if (res.code == "200") {
          }
        }, (err) => {
        }, 'member')
      }
    },
    // 点击专题跳转
    // toOuterLink: function (link, index) {
    //   sensors.track('OperateClick', {
    //     operate_name: "轮播图",
    //     operate_content: "大咖育儿",
    //     position: 3,
    //     content_name: "大咖育儿"

    //   })
    //   sensors.track('RecommendedClick', {
    //     content_name: index + 1
    //   })
    //   this.xmCourseClickGio({'floor_var': "大咖育儿", 'position_var': "视频坑位" + (index + 1), "contentName_var": ""});
    //   setTimeout(function () {
    //     location.href = link;
    //   }, 200)
    // },
    // 返回上一页
    goBack: function () {
      $(".course-content").css("marginTop", '0')
      $(".courseList").css("overflow", "auto");
      $(".tagAllListMask").css("display", "none")
      if (window.history.length > 1 && this.getCookie("fromPath")) {
        this.$router.go(-1);
      } else {
        this.$router.push({path: '/home'});
      }
    },
    // 搜索
    onSearch: function () {
      if (this.searchText !== "") {
        this.recordList = this.searchText;
      }
    },
    // 取消搜索
    onCancel: function () {
      this.searchText = "";
      this.layerFloatShowCourse = true;
      this.isCancelCourse = false;

    },
    // 搜索框值发生改变
    searchInput: function () {
      if (this.searchText == "") {
        this.layerFloatShowCourse = false;
      } else if (this.searchText.length >= 50) {
        this.searchText = this.searchText.slice(0, 50)
      }
    },
    // 搜索框获取焦点
    searchFocus: function () {
      // this.isCancelCourse = true;
      // this.layerFloatShowCourse = false;
      sessionStorage.setItem("searchVal", "course");
      this.$router.push({
        path: "/search",
        query: {
          searchIndex: "course",
        }
      })
      sensors.track('ClickSearch', {
        page_name: this.$route.meta.title,
      });
    },
    // 跳转到专家主页
    toExpertHome: function (item, type, name) {
      if (type == "本周好课") {
        this.xmCourseClickGio({'floor_var': type, 'position_var': type, "contentName_var": item.title});
      } else {
        this.xmCourseClickGio({'floor_var': type, 'position_var': name, "contentName_var": item.title});
      }
      var that = this;
      setTimeout(function () {
        that.$router.push({path: "/expertOnline/expertLists/" + item.expert.id});
      }, 200)
    },
    // 星妈课堂流量位点击Gio埋点
    xmCourseClickGio: function (gioParams) {
      gio('track', 'xmCourseClick', {
        'floor_var': gioParams.floor_var,
        'position_var': gioParams.position_var,
        "contentName_var": gioParams.contentName_var
      });
    },
    // 点击banner跳转
    toBannerClick: function (item, index) {

      sensors.track('OperateClick', {
        operate_name: '轮播图',
        operate_content: '',
        position: 1,
        content_name: ''
      })
      this.xmCourseClickGio({
        'floor_var': "运营位banner",
        'position_var': "活动坑位" + (index + 1),
        "contentName_var": ""
      });
      setTimeout(function () {
        location.href = item.link;
      }, 200)
    },
    // 点击马上报名流量位埋点
    gioFloorClick: function (title) {
      this.xmCourseClickGio({'floor_var': "本周好课", 'position_var': "下期预告", "contentName_var": title});
    },
    // 神策课程列表埋点
    sensorsCourseClick(course, type) {
      let firstName;
      let name;
      console.log(course, 'coursecourse')
      if (this.tagId != 0) {
        var curTag = course.tlist.find(item => item.id == this.switchTagId);
        name = curTag.name;
        firstName = this.tagListTitle.find(item => item.id == curTag.parentId).name
      } else {
        firstName = "精选课程"
        name = '精选课程'
      }
      sensors.track('CoursesList_Click', {
        Course_ID: course.id, //课程ID
        course_title: course.title, //课程标题
        CourseLearn_count: course.signUpNum, //课程学习人数
        course_class1: firstName, //课程一级分类
        course_class2: name, //课程二级分类
        expert_name: course.expert.realName, //专家姓名
        expert_hospital: course.expert.hospital, //专家单位
        expert_level: course.expert.position, //专家职称
        Click_Type: type
      });
    }
  }
};
</script>
